import {IndicatorSchema, IndicatorTissotFiltersValues} from '@pages/pilotage-rh/indicators/indicator-types';

import {IdToTextMapper, TranslationFn} from '../types/common-types';
import {Change} from './object-diff';

/**
 * Transforme les valeurs des filtres en labels lisibles
 */
export const mapFilterValuesToLabels = (changes: Record<string, Change>, t: TranslationFn): void => {
  // Extraire les clés du schéma config
  const configShape = IndicatorSchema._def.schema.shape.config.shape;
  const configKeys = Object.keys(configShape);

  Object.keys(changes).forEach((changeKey) => {
    const change = changes[changeKey];

    // Vérifier si changeKey correspond à une clé traduite du config
    const isConfigField = configKeys.some(
      (key) =>
        t(`pages.pilotage-rh.indicators.fields.${key}`) === changeKey ||
        t(`pages.pilotage-rh.indicators.fields.defaultDashboard`) === changeKey,
    );

    // Marquer les champs string du config comme 'select'
    if (typeof change.before === 'string' && typeof change.after === 'string' && isConfigField) {
      change.type = 'select';
    }

    // Vérifier si c'est un changement de filtre
    const filterMatch = Object.keys(IndicatorTissotFiltersValues).find((filterKey) => {
      if (filterKey === 'boolean') return true;
      const translatedKey = t(`pages.pilotage-rh.indicators.fields.filters.${filterKey}`);
      return changeKey === translatedKey;
    });

    if (filterMatch) {
      const filterKey = filterMatch as keyof typeof IndicatorTissotFiltersValues;
      const filterOptions = IndicatorTissotFiltersValues[filterKey];

      // Mapper les valeurs vers les labels
      const mapValuesToLabels = (values: unknown): unknown => {
        if (Array.isArray(values)) {
          return values.map((value) => {
            const option = filterOptions.find((opt) => opt.value === value);
            return option ? option.label : value;
          });
        }
        return values;
      };

      change.before = mapValuesToLabels(change.before);
      change.after = mapValuesToLabels(change.after);
    }
  });
};

/**
 * Transforme les IDs d'indicateur en texte lisible
 */
export const mapIndicatorIdToDisplayText = (
  changes: Record<string, Change>,
  getIndicatorDisplayText: IdToTextMapper,
): void => {
  if (changes.Configuration) {
    changes.Configuration.after = getIndicatorDisplayText(changes.Configuration.after as number);
    changes.Configuration.before = getIndicatorDisplayText(changes.Configuration.before as number);
    changes.Configuration.type = 'select';
  }
};
